module.exports = __webpack_public_path__ + "img/fruit-strawberries-350x184.c543eb30.jpg";